import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const moduleWSSApi = {
  namespaced: true,
  state: {
    id: null,
    src_num: null
  },
  mutations: {
    setCall(state, payload) {
      state.id = payload.id;
      state.src_num = payload.src_num;
    }
  },
  actions: {
    notify(context, payload) {
      if (payload && parseInt(payload.request.event) === 1 && parseInt(payload.request.dst_type) === 1) {
        context.commit('setCall', {
          id: payload.request.call_id,
          src_num: payload.request.src_num,
        });
      }
      if (payload && parseInt(payload.request.event) === 1 && parseInt(payload.request.dst_type) === 2) {
        if (context.state.id !== payload.request.call_id)
          return;
        axios.get(process.env.VUE_APP_BACKEND_URL + '/api/contacts/phone/' + context.state.src_num,
        ).then((response) => {
          this.isBusyButton = false;
          if (response) {
            if (response.data.error === false) {
              const contact = response.data.contact;
              const dst = response.data.dst;
              if (String(dst) === String(payload.request.short_dst_num))
                this._vm.$bvToast.toast('Звонок от ' + contact.first_name + ' ' + contact.middle_name + ' ' + contact.last_name + ' ['
                  + contact.phone + ']', {
                  title: 'Входящий звонок',
                  autoHideDelay: 30000,
                  href: '/contacts/' + contact.id,
                  appendToast: true,
                  variant: 'success',
                });
            }
          }
        })
      }

    },
  },
  getters: {}
}

export default new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    },
    newTlgMessages: false,
    funnels: []
  },
  mutations: {
    SOCKET_ONOPEN(state, event) {
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
      //console.log(event);
      Vue.prototype.$socket.sendObj({
        "type": "auth",
        "body": {
          "key": process.env.VUE_APP_WSS_KEY
        }
      });
    },
    SOCKET_ONCLOSE(state, event) {
      state.socket.isConnected = false
      console.log(event);
    },
    SOCKET_ONERROR(state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      state.socket.message = message;
      console.log(state, message);
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    },
    setFunnels(state, payload) {
      state.funnels = payload.funnels
    },
    setNewTlgMessages(state, payload) {
      state.newTlgMessages = payload
    },
  },
  getters: {
    funnels: state => {
      return state.funnels;
    },
    newTlgMessages: state => {
      return state.newTlgMessages;
    },

    getFunnelsList: state => {
      let list = [];
      state.funnels.forEach(funnel => {
        list.push({title: funnel.title, name: funnel.name})
      })
      return list;
    },
    funnelOptions: (state, getters) => {
      let opts = [];
      getters.getFunnelsList.forEach(e => {
        opts.push({value: e.name, text: e.title});
      });
      return opts;
    }
  },
  actions: {
    auth() {
      //Dummy
    },
    loadFunnels(context) {
      axios.get(process.env.VUE_APP_BACKEND_URL + '/api/deals/funnels', {})
        .then((response) => {
          if (response.data.funnels) {
            context.commit('setFunnels', {funnels: response.data.funnels})
          }
        })
    },
    handleTlgUpdates(context){
      const socket = new WebSocket('wss://crm-telegram.hyper-script.ru/ws');

      // socket.addEventListener('open', (event) => {
      //   socket.send('Hello Server!');
      // });

      socket.addEventListener('message', (event) => {
        let m = JSON.parse(event.data)
        if (m.event !== "pong")
          context.commit('setNewTlgMessages', true)
      });
    }
  },
  modules: {
    api: moduleWSSApi
  }
})
